import colorPalette from "@/common/constants/colorPalette";

const {
  COLOR_LANDSCAPE,
  COLOR_BORDERS,
  COLOR_WATER,
  COLOR_LINE,
  COLOR_POINT_FILL,
  COLOR_SELECTED_POINT
} = colorPalette;

const COLORS = {
  BORDERS: COLOR_BORDERS,
  LANDSCAPE: COLOR_LANDSCAPE,
  LINE: COLOR_LINE,
  POINT: COLOR_SELECTED_POINT,
  POINT_FILL: COLOR_POINT_FILL,
  WATER: COLOR_WATER
};

const POINT_MARKER_ICON_CONFIG = {
  url: require('../../components/tracking-widget/static/star.png'),
  strokeOpacity: 0.7,
  strokeWeight: 4,
  strokeColor: COLORS.DROP_OFF_MARKER,
  fillColor: COLORS.DROP_OFF_MARKER,
  fillOpacity: 0.7
};

const BREAK_ICON_CONFIG = {
  url: require('../../components/job/batch/static/break.svg'),
  strokeOpacity: 0.7,
  strokeWeight: 4,
  strokeColor: COLORS.DROP_OFF_MARKER,
  fillColor: COLORS.DROP_OFF_MARKER,
  fillOpacity: 0.7
}

const CAR_MARKER_ICON_CONFIG = {
  url: require('../../components/tracking-widget/static/icon-car.png'),
  strokeOpacity: 0.7,
  strokeWeight: 4,
  strokeColor: COLORS.DROP_OFF_MARKER,
  fillColor: COLORS.DROP_OFF_MARKER,
  fillOpacity: 0.7
};

const LINE_PATH_CONFIG = {
  clickable: false,
  geodesic: false,
  strokeOpacity: 1.0,
  strokeWeight: 2,
  strokeColor: COLORS.LINE,
};

const mapSettings = {
  clickableIcons: false,
  streetViewControl: false,
  panControlOptions: false,
  gestureHandling: "greedy",
  mapTypeControl: false,
  zoomControlOptions: {
    style: "SMALL"
  },
  zoom: 11,
  minZoom: 5,
  maxZoom: 16,
  styles: [
    {
      elementType: 'geometry',
      stylers: [{ color: '#f1f1f1' }],
    },
    {
      elementType: 'labels.text.fill',
      stylers: [{ color: '#707070' }],
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#464646' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi',
      elementType: 'geometry',
      stylers: [{ color: '#f9f9f9' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#ffffff' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#a8a8a8' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [{ color: '#f0d298' }, { weight: 1 }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#a8a8a8' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#ffffff' }],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#c1c6ca' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text',
      stylers: [{ visibility: 'off' }],
    },
  ],
};

export { mapSettings, LINE_PATH_CONFIG, POINT_MARKER_ICON_CONFIG, CAR_MARKER_ICON_CONFIG, BREAK_ICON_CONFIG};



// WEBPACK FOOTER //
// ./src/common/constants/mapSettings.js